import { httpClient } from 'utils/httpClient';
import { SunatConfig } from 'types/sunat.types';

export const sunatService = {
  async get(): Promise<SunatConfig> {
    return httpClient.get<SunatConfig>('/sunat');
  },
  async update(payload: SunatConfig): Promise<SunatConfig> {
    return httpClient.put<SunatConfig>('/sunat', payload);
  },
};
